import { render, staticRenderFns } from "./SidebarStyle3.vue?vue&type=template&id=f6821528&"
import script from "./SidebarStyle3.vue?vue&type=script&lang=js&"
export * from "./SidebarStyle3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports